module.exports = __webpack_public_path__ + "static/media/filters.e6adc8e0.svg";